export enum BuildingOverlayType {
  NONE,
  OVERLAY,
  BUILDING_TYPOLOGY,
  INTERNAL_OVERLAY,
  INFORMATIONAL_OVERLAY
}

export function getPrettyOverlayType(overlayType: number): string {
  return ['', 'Overlay', 'Building typology', 'Internal overlay', 'Informational overlay'][overlayType];
}
